<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-layout class="px-3" row wrap>
                <v-flex xs12>
                    <confirmation-header-text
                        :text="$vuetify.lang.t('$vuetify.permanent_address') +' of '+extendConvertVisaDetails.country_name"
                        class="ml-2"
                        icon="mdi-map-marker-radius"></confirmation-header-text>
                </v-flex>

                <v-flex xs12>
                    <list-item-detail
                        :sub_title="application_data.full_address"

                        :title="$vuetify.lang.t('$vuetify.full_address')"/>
                </v-flex>
                <v-flex xs12>
                    <v-divider class="my-3"></v-divider>
                </v-flex>
                <v-flex xs12>
                    <confirmation-header-text
                        :text="$vuetify.lang.t('$vuetify.reason_for_the_visa')"
                        class="ml-2"
                        icon="question_answer"></confirmation-header-text>
                </v-flex>
                <v-flex xs12>
                    <v-banner single-line v-if="application_data.reputation_field" class="custom-banner">
                        I have a good reputation in {{application_data.reputation_field}}
                    </v-banner>
                    <v-banner single-line v-if="application_data.contribution_field" class="custom-banner">
                        I would like to contribute in the {{application_data.contribution_field}} Field of Nepal.
                    </v-banner>
                    <v-banner single-line v-if="application_data.invested_million_dollar" class="custom-banner">
                        I have invested at least one million USD in Nepal.
                    </v-banner>
                    <v-banner single-line v-if="application_data.other_reason" class="custom-banner">
                        Others: {{application_data.other_reason}}
                    </v-banner>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaSingle.visa.extra.application_data;
            },
            extendConvertVisaDetails() {
                return this.$store.state.VisaSingle.extendConvertVisaDetail;
            }
        },
        components: {
            ListItemDetail,
            ConfirmationHeaderText
        }
    }
</script>
<style>
    .custom-banner div {
        padding-left:  4px !important;
    }

</style>

